export const AVIATION_QUESTIONS_DATA_REQUEST =
  'AVIATION_QUESTIONS_DATA_REQUEST';
export const AVIATION_QUESTIONS_DATA_SUCCESS =
  'AVIATION_QUESTIONS_DATA_SUCCESS';
export const AVIATION_QUESTIONS_DATA_FAIL = 'AVIATION_QUESTIONS_DATA_FAIL';
